// Debug: verify module loads
console.log('[PRODUCT_SERVER_TABLE] Module loading...');

// CRITICAL: Use window.jQuery directly everywhere to avoid webpack scope issues
// Do NOT use $ or declare var $ - webpack will override it with module-scoped jQuery

// Helper functions - must be defined before use
function parsePeriod(input){
    if (input == null || input === '') return 0;
    var srx = new RegExp(/^[0-9]+[.]?[0-9]*$/);
    var mrx = new RegExp(/([0-9][0-9]?)[ ]?m/);
    var hrx = new RegExp(/([0-9][0-9]?)[ ]?h/);
    var drx = new RegExp(/([0-9][0-9]?)[ ]?d/);
    var days = 0;
    var hours = 0;
    var minutes = 0;
    if (mrx.test(input)) {
        minutes = mrx.exec(input)[1];
    }
    if (hrx.test(input)) {
        hours = hrx.exec(input)[1];
    }
    if (drx.test(input)) {
        days = drx.exec(input)[1];
    }

    if (srx.test(input)) {
        return parseFloat(input);
    } else {
        return to_minutes(days, hours, minutes);
    }
}

function to_minutes(dd,hh,mm) {
    var d = parseInt(dd);
    var h = parseInt(hh);
    var m = parseInt(mm);
    if (isNaN(d)) d = 0;
    if (isNaN(h)) h = 0;
    if (isNaN(m)) m = 0;

    var t = d * 24 * 60 +
        h * 60 +
        m;
    return t;
}

function calc_total(current_row){
    var periodCell = window.jQuery('input.period', current_row);
    var period = parsePeriod(periodCell.val());
    var current_total_cell = window.jQuery('.total', current_row);
    var total = (period * current_total_cell.data('price')).toFixed(2);
    var enabled = total >= 10.0;
    if(enabled){
        window.jQuery('input[type="submit"]', current_row).prop('disabled', false);
        window.jQuery('input.period', current_row).removeClass('with-error');
    }
    else{
        window.jQuery('input[type="submit"]', current_row).prop('disabled', true);
        window.jQuery('input.period', current_row).addClass('with-error');
    }
}

// Click handler for Order/Prolong buttons - works with dynamically loaded content
// Event delegation doesn't require DOM ready - registers immediately on module load
console.log('[PRODUCT_SERVER_TABLE] Registering click handler, $ is:', typeof $);
window.jQuery(document).on('click', '#product-server-table.datatable input[type="submit"]', function () {
    console.log('[PRODUCT_SERVER_TABLE] Click handler fired!');

    var form = window.jQuery('form.order-submit');
    var button = window.jQuery(this);
    var productId = button.data('product-id');
    var periodType = button.data('period-type');
    var current_row = button.closest('tr');
    var period = parsePeriod(window.jQuery('input.period', current_row).val());
    var os = window.jQuery('select.os :selected', current_row).val();

    if (period == 0) {
        if (periodType == 'minute') {
            period = 30;
        } else if (periodType == 'week' || periodType == 'month') {
            period = 1;
        }
    }

    form.find('input#order_nomenclature_id').val(productId);
    form.find('input#prolong_nomenclature_id').val(productId);
    form.find('input#order_period_count').val(parsePeriod(period));
    form.find('input#prolong_period_count').val(parsePeriod(period));
    if (!os) {
        form.find('input#order_os').val(window.jQuery("#os_value_prolong").text());
    } else {
        form.find('input#order_os').val(os);
    }
    form.submit();
});

// Event handlers and initialization that need DOM ready
window.jQuery(document).on('turbolinks:load', function() {
    window.jQuery(document).on('change', '#product-server-table.datatable td .period', function () {
        var period = window.jQuery(this).val();
        var current_row = window.jQuery(this).closest('tr');
        var current_total_cell = window.jQuery('.total', current_row);
        var total = current_total_cell.data('currency') + (period * current_total_cell.data('price')).toFixed(2);
        current_total_cell.text(total);
        calc_total(current_row);
    });

    window.jQuery('#product-server-table.datatable').on('change', '.durationpicker-duration', function () {
        var current_row = window.jQuery(this).closest('tr');
        var periodCell = window.jQuery('input.period', current_row);
        var period = parsePeriod(periodCell.val());
        if (period < 30) {
            window.jQuery('#duration-minutes', current_row).val(30);
            periodCell.val(30);
            period = 30;
        }
        var current_total_cell = window.jQuery('.total', current_row);
        var total = current_total_cell.data('currency') + (period * current_total_cell.data('price')).toFixed(2);
        current_total_cell.text(total);
        calc_total(current_row);
    });

    window.jQuery('input.period[type=text]').each(function () {
        window.jQuery(this).durationPicker({
            days: {
                label: 'd',
                min: 0,
                max: 30
            },
            hours: {
                label: 'h',
                min: 0,
                max: 23
            },
            minutes: {
                label: 'm',
                min: 0,
                max: 59
            },
            classname: "form-control input-sm",
            type: 'number',
            responsive: true
        });
    });
});
window.addEventListener('load', () => {
    if (!window.location.hash) return;

    const id = window.location.hash.slice(1);
    let hasScrolled = false;

    function tryScroll() {
        const el = document.getElementById(id);
        if (el && !hasScrolled) {
            el.scrollIntoView();
            hasScrolled = true;
        }
    }

    tryScroll();

    setTimeout(tryScroll, 100);

    setTimeout(tryScroll, 500);
});


